
	import { Diaries, DiaryAnswer } from "@/domain/entities/DiaryQuestion";
	import { LikertRecord } from "@/domain/entities/Likert";
	import { now } from "@/domain/entities/EntityFields";
	import { computed, defineComponent, PropType, ref } from "vue";
import { DateTime } from "luxon";

	interface DiariesLikertJoint {
		diaryAnswers: DiaryAnswer[];
		likertRecords: LikertRecord[];
	}
	interface DiariesAndLikert {
		[diaryDate: string]: DiariesLikertJoint;
	}

	export default defineComponent({
		props: {
			createdAt: {
				type: Date,
			},
			diaries: {
				type: Object as PropType<Diaries>,
			},
			likertRecords: {
				type: Array as PropType<LikertRecord[]>,
				default: () => [],
			},
		},
		setup(props) {
			let createdAt = new Date(props.createdAt!);
			
			let today = now()// new Date();
			var difference = today.toMillis() - createdAt.getTime();
			var days = Math.ceil(difference / (1000 * 3600 * 24));

			let likertAndDiaries = computed(
				(): DiariesAndLikert => {
					let likertDiariesJoint: DiariesAndLikert = {};

					if (props.diaries !== undefined) {
						for (let i = 0; i < days; i++) {
							let key = today.minus({days: i}).toFormat('dd/MM/y');
							let likertRecords = props.likertRecords.filter(
								(lr) => DateTime.fromJSDate(new Date(lr.date)).toFormat('dd/MM/y') === key
							);

							likertDiariesJoint[key] = {
								diaryAnswers: props.diaries![key] || [],
								likertRecords: [...likertRecords],
							};
						}
					}

					return likertDiariesJoint;
				}
			);

			const activeElement = ref<string>("");

			function averageLikert(records: LikertRecord[]): string {
				return (records.reduce((acc: number, l) => l.score + acc, 0) / records.length).toFixed(2);
			}
			return {
				likertAndDiaries,
				activeElement,
				averageLikert,
			};
		},
	});
